const PageNotFound = () => (
  <div className="flex min-h-screen items-center justify-center text-2xl">
    404 Page Not Found
  </div>
);

export default PageNotFound;
